const accessKeysEN = {
    "view": {
        "title": "Access Keys",
        "form": {
            "label": {
                "accessKeyId": "Access Key ID",
                "secretAccessKey": "Secret Access Key"
            },
            "button": {
                "hide": "Hide",
                "reveal": "Reveal"
            },
            "message": {
                "accessKeyIdCopied": "Access Key ID copied to clipboard!",
                "secretAccessKeyCopied": "Secret Access Key copied to clipboard!"
            }
        },
        "uploadInstructions": {
            "title": "Instructions",
            "step1": {
                "title": "Step 1 - Download upload tool",
                "description": "Download the <1>Cyberduck</1> tool."
            },
            "step2": {
                "title": "Step 2 - Make a copy of Upload Spreadsheet and save the Trigger file",
                "descriptionPoint1": "Copy this <1><strong>SPREADSHEET</strong></1> to your GOOGLE DRIVE.",
                "descriptionPoint2": "Save this <1><strong>TRIGGER FILE</strong></1> to your computer or cloud storage.",
            },
            "step3": {
                "title": "Step 3 - Establish the connection",
                "descriptionPoint1": "Open the Cyberduck tool.",
                "descriptionPoint2": "In the lower-left corner click on the + icon. (Add new bookmark).",
                "descriptionPoint3": "Input following credentials:",
                "descriptionPoint4": "Access Key ID: ",
                "descriptionPoint5": "Secret Access Key: ",
                "descriptionPoint6": "Your S3 Folder: ",
                "descriptionPoint7": "Your S3 Path : ",
                "descriptionPoint8": "Follow these steps:",
            },
            "step4": {
                "title": "Step 4 - Fill in the metadata",
                "description": "Fill in the metadata according to the instructions from our Help Center."
            },
            "step5": {
                "title": "Step 5 - Files and Genres",
                "descriptionPoint1": "Upload your <1>metadata.csv</1> file and all audio <3>(.wav)</3> and <5>image (.jpg)</5> files, <7> NOT (.jpeg)</7>",
                "descriptionPoint2": "<strong>JPG files</strong> must be <strong>3000x3000 px, max files size 4MB</strong>",
                "descriptionPoint3": "Audio files must be only <strong>wav, 16 bit, 44.1 khz</strong>",
                "descriptionPoint4": "Root file names must be one word",
                "descriptionPoint5": "<strong>IMPORTANT:</strong> Be aware of <2><strong>ML Dance Genres</strong></2> and matching in the stores such as Beatport.",
            },
            "step6": {
                "title": "Step 6 - Upload Trigger",
                "description": "After all the files are uploaded, please upload this empty trigger file <1>“last.zzz”</1>. Monitor your email for any notifications."
            },
            "step7": {
                "title": "Advice - Test with us before uploading",
                "description": "Feel free to contact our support team with any questions regarding this way of release creation. This is a very simple process that relies on more robust technologies such as AWS S3 and does not rely on browser technologies. However, it requires your metadata to be 100 % accurate. Music Link team can test upload a few releases for you with your metadata to detect possible issues."
            }
        }
    }
};

export default accessKeysEN;
